import { useAuthRedirect } from 'hooks/useAuthRedirect'

const AuthRedirect = () => {
  useAuthRedirect()
  return null
}

export { AuthRedirect }
